import { ReactNode } from "react";

export const ArrowLeft = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15 15.875L11.12 11.995L15 8.11498C15.1873 7.92814 15.2925 7.67449 15.2925 7.40998C15.2925 7.14546 15.1873 6.89181 15 6.70498C14.61 6.31498 13.98 6.31498 13.59 6.70498L9.00001 11.295C8.61001 11.685 8.61001 12.315 9.00001 12.705L13.59 17.295C13.98 17.685 14.61 17.685 15 17.295C15.38 16.905 15.39 16.265 15 15.875Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const ArrowRight = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9 8.12502L12.88 12.005L9.00001 15.885C8.81275 16.0719 8.70752 16.3255 8.70752 16.59C8.70752 16.8545 8.81275 17.1082 9.00001 17.295C9.39001 17.685 10.02 17.685 10.41 17.295L15 12.705C15.39 12.315 15.39 11.685 15 11.295L10.41 6.70502C10.02 6.31502 9.39 6.31502 9 6.70502C8.62 7.09503 8.61 7.73502 9 8.12502Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const ArrowUp = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.12499 15L12.005 11.12L15.885 15C16.0718 15.1872 16.3255 15.2925 16.59 15.2925C16.8545 15.2925 17.1082 15.1872 17.295 15C17.685 14.61 17.685 13.98 17.295 13.59L12.705 8.99999C12.315 8.60999 11.685 8.60999 11.295 8.99999L6.70499 13.59C6.31499 13.98 6.31499 14.61 6.70499 15C7.09499 15.38 7.73499 15.39 8.12499 15Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const ArrowDown = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.875 9.00001L11.995 12.88L8.11501 9.00001C7.92817 8.81275 7.67452 8.70752 7.41001 8.70752C7.14549 8.70752 6.89184 8.81275 6.70501 9.00001C6.31501 9.39001 6.31501 10.02 6.70501 10.41L11.295 15C11.685 15.39 12.315 15.39 12.705 15L17.295 10.41C17.685 10.02 17.685 9.39001 17.295 9.00001C16.905 8.62001 16.265 8.61001 15.875 9.00001Z"
				fill="currentColor"
			/>
		</svg>
	);
};
